import React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

interface ICostBreakdownExcelDialogProps {
    dialogName: string;
    initialFilename: string;
    onCancel: () => void;
    onConfirm: (filename: string, reportPath: string) => void;
}

// Mirrors oid 38's Excel Filename/Format popup. Format isn't a generic output-file-type picker -
// it selects which of 3 separate SSRS reports renders (Standard/Req-Landman/Budget-Margin), mirroring
// Oracle's :excel.format driving XL_Cost_Breakdown vs XL_Cost_Breakdown_Overview. The popup's Browse
// button (webutil_file.file_save_dialog, a native Windows Save As picker) has no web equivalent - a
// browser can't be made to open a native file-system picker - so Filename here is just an editable
// suggested name fed to the browser's own download flow, and Browse is dropped rather than faked.
const REPORT_PATH_OPTIONS = [
    { value: 'CostBreakdown', label: 'Standard' },
    { value: 'costBreakdownReq', label: 'Req / Landman' },
    { value: 'costBreakdownReqBudget', label: 'Budget / Margin' },
];

const CostBreakdownExcelDialog = (props: ICostBreakdownExcelDialogProps) => {
    const { register, getValues } = useForm();

    const handleOk = () => {
        const values = getValues();
        props.onConfirm(values.filename || props.initialFilename, values.reportPath || REPORT_PATH_OPTIONS[0].value);
    };

    return (
        <Dialog title="Excel Report" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <RHFInputBox
                label="Filename"
                labelOnLeft={true}
                name="filename"
                register={register}
                defaultVal={props.initialFilename}
                style={{ width: '100%' }}
                bodyStyle={{ width: '100%', marginBottom: '.75rem' }}
            />
            <RHFSelect
                label="Format"
                labelOnLeft={true}
                name="reportPath"
                register={register}
                options={REPORT_PATH_OPTIONS}
                defaultVal={REPORT_PATH_OPTIONS[0].value}
                style={{ width: '100%' }}
                bodyStyle={{ width: '100%', marginBottom: '1rem' }}
            />
            <div className="form-row" style={{ justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ marginRight: '1rem' }} text="OK" onClick={() => handleOk()} />
                <Button className="blue-hover-button" text="Cancel" onClick={() => props.onCancel()} />
            </div>
        </Dialog>
    );
};

export default CostBreakdownExcelDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/CostBreakdownExcelDialog.tsx